module.exports = __webpack_public_path__ + "img/DickeBacken.63fa422c.jpg";